import React from 'react';
import './marketingRequest info.css'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBModal, MDBModalBody, MDBModalHeader } from "mdbreact";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { message, DatePicker } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import { hasValue } from "../../validations/validations";
import moment from 'moment';

class marketingRequestInfo extends React.Component {
    state = {
        actionType: this.props.location.state.actionType ? this.props.location.state.actionType === "EDIT" ? "EDIT" : "VIEW" : "VIEW",
        id: this.props.location.state.data.id,
        status: this.props.location.state.data.status,
        licenseNumber: this.props.location.state.data.licenseNumber,
        licenseEndDate: this.props.location.state.data.licenseEndDate,
        reason: '',
        project: this.props.location.state.data.project ? this.props.location.state.data.project : null,
        marketer: this.props.location.state.data.marketer ? this.props.location.state.data.marketer : null,
        pages: 1,
        page: 1,
        modal: false,
        license: this.props.location.state.data.license ? this.props.location.state.data.license : null,
        licenseType: 'url',
        licenseName: [],
        modalType: 'ACCEPT'
    };

    constructor(props) {
        super(props)
        window.scrollTo(0, 0)
        if (this.props.isRTL) {
            allStrings.setLanguage('ar')
        } else {
            allStrings.setLanguage('en')
        }
    }

    componentDidMount() {
        if (this.props.isRTL) {
            allStrings.setLanguage('ar')
        } else {
            allStrings.setLanguage('en')
        }
    }
    delete = () => {
        let l = message.loading('Wait..', 2.5)
        axios.delete(`${BASE_END_POINT}marketingRequests/${this.props.location.state.data.id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            },
        })
            .then(response => {
                console.log("marketingRequest DELETED")
                l.then(() => message.success(allStrings.done, 2.5))
                this.props.history.goBack()
            })
            .catch(error => {
                console.log(error.response)
                l.then(() => message.error(allStrings.error, 2.5))
            })
    }
    onProgress = () => {
        let l = message.loading('Wait..', 2.5)
        axios.put(`${BASE_END_POINT}marketingRequests/${this.props.location.state.data.id}/onProgress`, {}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            },
        })
            .then(response => {
                console.log("marketingRequest onProgress")
                l.then(() => message.success(allStrings.done, 2.5))
                this.props.history.goBack()
            })
            .catch(error => {
                console.log(error.response)
                l.then(() => message.error(allStrings.error, 2.5))
            })
    }
    reject = () => {
        let l = message.loading('Wait..', 2.5)
        const { reason } = this.state
        if (hasValue(reason)) {
            let data = {
                reason: reason
            }
            axios.put(`${BASE_END_POINT}marketingRequests/${this.props.location.state.data.id}/reject`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.currentUser.token}`,
                    'Accept-Language': this.props.isRTL ? 'ar' : 'en',
                },
            }).then(response => {
                console.log("marketingRequest reject")
                l.then(() => message.success(allStrings.done, 2.5))
                this.toggle('REJECT')
                this.props.history.goBack()
            })
                .catch(error => {
                    console.log(error.response)
                    l.then(() => message.error(allStrings.error, 2.5))
                })
        }
    }
    accept = () => {
        const { license, licenseNumber, licenseEndDate, licenseType } = this.state
        if (license !== null && hasValue(licenseNumber) && hasValue(licenseEndDate)) {
            let l = message.loading('Wait..', 2.5)
            let data = new FormData()
            data.append('licenseNumber', licenseNumber)
            data.append('licenseEndDate', licenseEndDate)
            if (license != null && licenseType === "data") {
                data.append('license', license)
            }
            console.log(Array.from(data))

            axios.put(`${BASE_END_POINT}marketingRequests/${this.props.location.state.data.id}/accept`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${this.props.currentUser.token}`,
                    'Accept-Language': this.props.isRTL ? 'ar' : 'en'
                },
            })
                .then(response => {
                    l.then(() => message.success(allStrings.done, 2.5))
                    this.toggle('ACCEPT')
                    this.props.history.goBack()
                })
                .catch(error => {
                    console.log(error.response)
                    l.then(() => message.error(allStrings.error, 2.5))
                })
        }
    }
    submitHandlerAccept = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        this.state.modalType === "REJECT" ? this.reject() : this.accept()

    };
    toggle = (type) => {
        this.setState({
            modal: !this.state.modal,
            modalType: type
        });
    }
    modal = () => (
        <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
            <MDBModalHeader toggle={this.toggleForComplete} >{allStrings.completeData}</MDBModalHeader>
            <MDBModalBody>
                <MDBContainer>
                    <MDBRow>
                        <MDBCol md="12">
                            <form style={{ paddingTop: '1rem' }}
                                className="needs-validation"
                                onSubmit={this.submitHandlerAccept}
                                noValidate
                            >
                                <div className="grey-text">
                                    {this.state.modalType === "REJECT" &&
                                        <MDBRow>
                                            <MDBCol md="12">
                                                <div className="md-form">
                                                    <label htmlFor="form920" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.reason}</label>
                                                    <br></br>
                                                    <input value={this.state.reason} name="reason" onChange={this.changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="form920" className="form-control" validate required placeholder="أدخل السبب..." />
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                </div>
                                            </MDBCol>
                                        </MDBRow>
                                    }{this.state.modalType === "ACCEPT" &&
                                        <div>
                                            <MDBRow>
                                                <MDBCol md="12">
                                                    <div className="md-form">
                                                        <label htmlFor="form920" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.licenseNumber}</label>
                                                        <br></br>
                                                        <input value={this.state.licenseNumber} name="licenseNumber" onChange={this.changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="form920" className="form-control" validate required placeholder="أدخل رقم الترخيص..." />
                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            <MDBRow>
                                                <MDBCol md="12">
                                                    <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.licenseEndDate}</label>
                                                    <DatePicker
                                                        dropdownAlign={{ points: ['bl', 'tl'] }}
                                                        placement="topLeft"
                                                        showTime={{ use12Hours: true, format: 'h:mm A' }}
                                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', marginBottom: '1rem' }}
                                                        onChange={(date, dateString) => {
                                                            console.log(dateString)
                                                            this.setState({ licenseEndDate: dateString })
                                                        }}
                                                        placeholder={allStrings.licenseEndDate}
                                                    />
                                                </MDBCol>
                                            </MDBRow>
                                            <MDBRow>
                                                <MDBCol md="12">
                                                    <div className="fileUpload2">
                                                        <input key={this.state.license} type='file' className="upImgs2" onChange={this.fileChangedHandlerLicense} ></input>
                                                        <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.upload}</span></span>
                                                    </div>
                                                    <div className="preview">
                                                        {this.state.license &&
                                                            <div style={{ display: "inline-block", width: '100%', border: '1px solid mediumaquamarine' }}>
                                                                <img alt="" src={this.state.licenseType === "data" ? URL.createObjectURL(this.state.license) : this.state.license} className="previewImg2" />

                                                                <span className="imgName">{this.state.licenseName}</span>
                                                                <MDBIcon icon="trash" className="mr-2 removeImg2"
                                                                    onClick={() => this.removeLicense()}  ></MDBIcon>
                                                            </div>
                                                        }
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                        </div>
                                    }
                                </div>
                                <div className="drawer-action-footer">
                                    <MDBBtn type="button" className="btn-cancel" onClick={this.toggle}>
                                        إلغاء
                                    </MDBBtn>
                                    <MDBBtn type="submit" className="btn-submit">
                                        {allStrings.send}
                                    </MDBBtn>
                                </div>
                            </form>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </MDBModalBody>
        </MDBModal>
    );
    fileChangedHandlerLicense = event => {
        this.setState({
            license: event.target.files[0],
            licenseName: event.target.files[0].name,
            licenseType: "data"
        })
    }
    removeLicense = () => {
        this.setState({
            license: null,
            licenseName: '',
            licenseType: "url"
        });
    }
    submitHandler = event => {
        event.preventDefault();
        console.log(event.target.className)
        event.target.className += " was-validated";
    };

    changeHandler = event => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    render() {
        if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('MARKETING-REQUESTS')) return <Redirect to='/Home' />

        return (
            <div className="App">
                <MDBContainer>
                    <MDBRow>
                        <MDBCol md="12">
                            {this.state.actionType === "VIEW" &&
                                <MDBBtn onClick={() => { this.delete() }} rounded style={{ display: 'inline-block', width: 'fit-content', margin: '8px', background: 'linear-gradient(135deg, #FF3547, #B71C1C)', color: '#fff', borderRadius: '10px' }} color="FF3547" className="btn-block z-depth-1a">
                                    <MDBIcon icon="trash-alt" className="mr-2" />
                                    {allStrings.remove}
                                </MDBBtn>
                            }
                            {this.state.actionType === "VIEW" && this.state.status === "PENDING" &&
                                <MDBBtn
                                    onClick={() => { this.onProgress() }}
                                    color="none"
                                    style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}
                                    rounded
                                    className="btn-block z-depth-1a"
                                >
                                    {allStrings.onProgress}

                                </MDBBtn>

                            }
                            {this.state.actionType === "VIEW" && (this.state.status === "PENDING" || this.state.status === "ON-PROGRESS") &&
                                <MDBBtn
                                    onClick={() => { this.toggle('ACCEPT') }}
                                    color="none"
                                    style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}
                                    rounded
                                    className="btn-block z-depth-1a"
                                >
                                    {allStrings.accept}

                                </MDBBtn>

                            }
                            {this.state.actionType === "VIEW" && (this.state.status === "PENDING" || this.state.status === "ON-PROGRESS") &&
                                <MDBBtn
                                    onClick={() => { this.toggle('REJECT') }}
                                    color="none"
                                    style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}

                                    rounded
                                    className="btn-block z-depth-1a"
                                >
                                    {allStrings.reject}

                                </MDBBtn>

                            }
                        </MDBCol>
                    </MDBRow>
                    <MDBRow>
                        {this.modal()}
                        <MDBCol md="12" >
                            <div className="infoCard">
                                <Card className="editCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>
                                    <CardMedia
                                        style={{ height: "0px" }}
                                    />
                                    <CardHeader></CardHeader>
                                    <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                                        <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                                            <span className="material-icons" style={{ color: 'white', fontSize: 20 }}>attach_money</span>
                                        </div>
                                        <div className="tableTitle" style={{
                                            display: 'inline-block', marginTop: '-60px',
                                            marginLeft: '0', marginRight: '0'
                                        }}>
                                            <p>{this.state.actionType === "VIEW" ? allStrings.info : allStrings.edit}</p>
                                        </div>
                                    </div>
                                    <CardContent style={{ minHeight: "390px", outline: 'none' }}>
                                        <MDBContainer>

                                            <MDBRow>
                                                <MDBCol md="12">
                                                    <form
                                                        className="needs-validation"
                                                        onSubmit={this.submitHandler}
                                                        noValidate
                                                    >

                                                        <div className="grey-text">
                                                            <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>#</label>
                                                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.id} type="text" id="form8" className="form-control" onChange={this.changeHandler} validate />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form56" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.status}</label>
                                                                        <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.status === "PENDING" ? allStrings.pending : this.state.status === "ON-PROGRESS" ? allStrings.onProgress : this.state.status === "ACCEPTED" ? allStrings.accepted : allStrings.rejected} type="text" id="form56" name="status" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل البيانات..." />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                            </MDBRow>
                                                            {this.state.licenseNumber &&
                                                                <MDBRow>
                                                                    <MDBCol md="6">
                                                                        <div className="md-form">
                                                                            <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.licenseNumber}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.licenseNumber} type="text" id="form8" name='licenseNumber' className="form-control" onChange={this.changeHandler} validate />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="6">
                                                                        <div className="md-form">
                                                                            <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.licenseEndDate}</label>
                                                                            <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={moment(this.state.licenseEndDate).format('YYYY-MM-DD')} type="text" id="form645" name="licenseEndDate" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل البيانات..." />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }{this.state.project &&
                                                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                    <MDBCol md="10" xs="10">
                                                                        <div class="md-form">
                                                                            <label htmlFor="form80" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.project}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.project ? this.state.project.name : 'مشاهده المشروع'} type="text" id="form80" class="form-control" />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="2" xs="2">

                                                                        <p style={{ textAlign: 'center', marginTop: '2.3rem', color: '#2BBBAD' }}>
                                                                            <span style={{ cursor: 'pointer', position: 'absolute', padding: '3px' }} class="material-icons"
                                                                                onClick={() => { this.props.history.push('projectInfo', { data: { id: this.state.project.id } }) }}>
                                                                                remove_red_eye
                                                                            </span>
                                                                            <span style={{ cursor: 'pointer', fontSize: '16px', fontWeight: '500', marginLeft: '2rem' }}
                                                                                onClick={() => { this.props.history.push('projectInfo', { data: { id: this.state.project.id } }) }}>
                                                                                {allStrings.show}
                                                                            </span>
                                                                        </p>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }
                                                            {this.state.marketer &&
                                                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                    <MDBCol md="5" xs="5">
                                                                        <div class="md-form">
                                                                            <label htmlFor="form80" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.marketer}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.marketer ? this.state.marketer.fullname : ''} type="text" id="form80" class="form-control" />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="5" xs="5">
                                                                        <div class="md-form">
                                                                            <label htmlFor="form80" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.phone}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.marketer ? this.state.marketer.phone : ''} type="text" id="form80" class="form-control" />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="2" xs="2">

                                                                        <p style={{ textAlign: 'center', marginTop: '2.3rem', color: '#2BBBAD' }}>
                                                                            <span style={{ cursor: 'pointer', position: 'absolute', padding: '3px' }} class="material-icons"
                                                                                onClick={() => { this.props.history.push('userInfo', { data: this.state.marketer }) }}>
                                                                                remove_red_eye
                                                                            </span>
                                                                            <span style={{ cursor: 'pointer', fontSize: '16px', fontWeight: '500', marginLeft: '2rem' }}
                                                                                onClick={() => { this.props.history.push('userInfo', { data: this.state.marketer }) }}>
                                                                                {allStrings.show}
                                                                            </span>
                                                                        </p>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }{this.state.license != null &&
                                                                <div>
                                                                    <a href={this.state.license} target="blank" style={{
                                                                        background: '#1D9598',
                                                                        color: '#fff',
                                                                        padding: '4px 40px 6px',
                                                                        marginLeft: '15px',
                                                                        fontFamily: 'Cairo',
                                                                        fontSize: '13px'
                                                                    }}
                                                                    >
                                                                        {allStrings.openFile}
                                                                    </a>
                                                                </div>
                                                            }


                                                        </div>
                                                        <br></br>
                                                        <br></br>
                                                        <div className="text-center">


                                                        </div>
                                                    </form>
                                                </MDBCol>
                                            </MDBRow>
                                        </MDBContainer>
                                    </CardContent>
                                </Card>
                            </div>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </div>
        )
    }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};

export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(marketingRequestInfo)
);
